<template>
  <div id="page-user-view">
    <vs-alert color="danger" title="User Not Found" :active.sync="service_request_not_found">
      <span>Service Request record with id: {{ $route.params.id }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'service-request'}" class="text-inherit underline">All Service Request</router-link>
      </span>
    </vs-alert>

    <div id="user-data" v-if="service_request_data">
      <vx-card title="Service Request Details" class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Bride Name</td>
                <td><router-link :to="`/admin/users/bride/view/${service_request_data.user.id}`" class="text-inherit underline hover:text-primary">{{ service_request_data.user.name }}</router-link></td>
              </tr>
              <tr>
                <td class="font-semibold">Event Name</td>
                <td><router-link :to="`/admin/event/view/${service_request_data.event.id}`" class="text-inherit underline hover:text-primary">{{ service_request_data.event.name }}</router-link></td>
              </tr>
              <tr>
                <td class="font-semibold">Event Date</td>
                <td>{{ service_request_data.event.event_date }}</td>
              </tr>
              <tr>
                <td class="font-semibold">County</td>
                <td>{{ service_request_data.event.county_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Location</td>
                <td>{{ service_request_data.event.location }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Category</td>
                <td>{{ service_request_data.category_name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Budget</td>
                <td>${{ service_request_data.budget }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Created Date</td>
                <td>{{ service_request_data.event_created_date | moment("MMM D YYYY, h:mm a")}}</td>
              </tr>
              <tr>
                <td class="font-semibold">Expiry Date</td>
                <td>{{ service_request_data.expiry_date | moment("MMM D YYYY, h:mm a")}}</td>
              </tr>
              <tr>
                <td class="font-semibold">Quote Expiry</td>
                <td>{{ service_request_data.quote_expiry_date | moment("MMM D YYYY, h:mm a")}}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <!--<vs-button
              icon-pack="feather"
              icon="icon-edit"
              class="mr-4"
              :to="{name: 'service-request-edit', params: { id: $route.params.id }}"
            >Edit</vs-button>-->
            <!--<vs-button
              type="border"
              color="danger"
              icon-pack="feather"
              icon="icon-trash"
              @click="confirmDeleteRecord"
            >Delete</vs-button>-->
          </div>
        </div>
      </vx-card>

      <vx-card>
        <vs-tabs :value="tab">
          <vs-tab label="Vendors" icon-pack="feather" v-if="service_request_data.vendors.length" icon="icon-user">
            <div>
              <vs-table search @selected="directToVendor" max-items="10" pagination :data="service_request_data.vendors">
                <template slot="thead">
                  <vs-th>Name</vs-th>
                  <vs-th>Business</vs-th>
                  <vs-th>County</vs-th>
                  <vs-th>Location</vs-th>
                  <vs-th>Min Budget</vs-th>
                  <vs-th>Distance</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>

                    <vs-td :data="data[indextr].vendor_professional.business_name">{{ data[indextr].vendor_professional.business_name }}</vs-td>

                    <vs-td :data="data[indextr].vendor_professional.county_name">{{ data[indextr].vendor_professional.county_name }}</vs-td>

                    <vs-td :data="data[indextr].vendor_professional.location">{{ data[indextr].vendor_professional.location }}</vs-td>

                    <vs-td :data="data[indextr].vendor_additional.attributes.budget">{{ data[indextr].vendor_additional.attributes.budget }}</vs-td>

                    <vs-td :data="data[indextr].vendor_additional.attributes.willing_to_travel">{{ data[indextr].vendor_additional.attributes.willing_to_travel }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-tab>

          <vs-tab label="Quotes" icon-pack="feather" v-if="service_request_data.quotes.length" icon="icon-user">
            <div>
              <vs-table @selected="directToVendorFromQuote" search max-items="10" pagination :data="service_request_data.quotes">
                <template slot="thead">
                  <vs-th>Business Name</vs-th>
                  <vs-th>Quote Amount</vs-th>
                  <vs-th sort-key="is_accepted">Accepted</vs-th>
                  <vs-th>Date</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="data[indextr].vendor.business_name">{{ data[indextr].vendor.business_name }}</vs-td>

                    <vs-td :data="data[indextr].quote_amount">$ {{ data[indextr].quote_amount }}</vs-td>

                    <vs-td :data="data[indextr].is_accepted"><feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', (data[indextr].is_accepted ? 'text-primary' : 'text-grey')]" /></vs-td>

                    <vs-td :data="data[indextr].created_at">{{ data[indextr].created_at | moment("MMM D YYYY, h:mm a") }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-tab>

          <vs-tab label="Transaction" icon-pack="feather" v-if="service_request_data.transactions.length" icon="icon-dollar-sign">
            <div>
              <vs-table max-items="10" @selected="directToTransaction" pagination :data="service_request_data.transactions">
                <template slot="thead">
                  <vs-th>Order ID</vs-th>
                  <vs-th>Amount</vs-th>
                  <vs-th>Payment Method</vs-th>
                  <vs-th>Payment Status</vs-th>
                  <vs-th>Date</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].order_id">{{ data[indextr].order_id }}</vs-td>

                    <vs-td :data="data[indextr].amount">${{ data[indextr].amount }}</vs-td>

                    <vs-td :data="data[indextr].payment_method">{{ data[indextr].payment_method }}</vs-td>

                    <vs-td :data="data[indextr].payment_status"><feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', (data[indextr].payment_status ? 'text-primary' : 'text-grey')]" /></vs-td>

                    <vs-td :data="data[indextr].updated_at">{{ data[indextr].updated_at  | moment("MMM D YYYY, h:mm a") }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-tab>

          <vs-tab label="Conversations" icon-pack="feather"  v-if="service_request_data.conversations && service_request_data.conversations.length"  icon="icon-file">
            <div>
              <vs-table @selected="directToConversation" search max-items="10" pagination :data="service_request_data.conversations" v-if="!showChat">
                <template slot="thead">
                  <vs-th>Business Name</vs-th>
                  <vs-th>Last Message</vs-th>
                  <vs-th>Location</vs-th>
                  <vs-th>Date</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="data[indextr].vendor.vendor_professional.business_name">{{ data[indextr].vendor.vendor_professional.business_name }}</vs-td>
                    <vs-td :data="data[indextr].message_last" style="max-width: 200px; overflow: hidden;  white-space: nowrap; text-overflow: ellipsis;">{{ data[indextr].message_last }}</vs-td>
                    <vs-td :data="data[indextr].vendor.vendor_professional.location">{{ data[indextr].vendor.vendor_professional.location }}</vs-td>
                    <vs-td :data="data[indextr].created_at">{{ data[indextr].created_at  | moment("MMM D YYYY, h:mm a") }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>

            <div class="vx-col w-full mb-base" v-if="showChat">
                <vx-card :title="chatTitle" class="overflow-hidden">
                    <template slot="actions">
                      <feather-icon @click="closeChat" icon="XIcon" class="ml-4" />
                    </template>
                    <template slot="no-body">
                        <div class="chat-card-log">
                            <component :is="scrollbarTag" ref="chatLogPS" class="scroll-area pt-6 px-6" :settings="settings" :key="$vs.rtl">
                                <ul ref="chatLog">
                                        <li class="flex items-start" :class="{'flex-row-reverse': msg.isSent, 'mt-4': index}" v-for="(msg, index) in chatLog" :key="index">
                                            <vs-avatar size="40px" class="m-0 flex-shrink-0" :class="msg.isSent ? 'ml-3' : 'mr-3'" :src="msg.senderImg" :alt="msg.timestamp"></vs-avatar>
                                            <div class="msg relative bg-white shadow-md py-3 px-4 mb-2 rounded-lg max-w-md" :class="{'chat-sent-msg border border-solid d-theme-border-grey-light': msg.isSent, 'border border-solid d-theme-border-grey-light': !msg.isSent}">
                                                <span v-if="msg.type =='image' && (typeof msg.file !== 'undefined')">
                                                  <a :href="msg.file" target="_blank">
                                                    <img  :src="msg.src" style="max-width: 150px" />
                                                  </a>
                                                </span>
                                                <span v-else-if="msg.type =='image'">
                                                  <a :href="msg.src" target="_blank">
                                                    <img  :src="msg.src" style="max-width: 150px"/>
                                                  </a>
                                                </span>
                                                </span>
                                                <span v-else>{{ msg.msg }}</span>
                                                <br>
                                                <div style="font-size:9px; font-family: verdana" :class="msg.isSent ? 'text-right' : ''">
                                                  {{msg.timestamp |  moment("lll")}}
                                                </div>
                                            </div>
                                        </li>
                                </ul>
                            </component>
                        </div>
                    </template>
                </vx-card>
            </div>
          </vs-tab>

          <vs-tab label="Attributes" icon-pack="feather"  icon="icon-file">
            <table>
              <tr v-for="(value, field) in service_request_data.attributes" v-if="value" v-bind:key="field">
                <td class="font-semibold">
                  {{ field }}
                  <span v-if="fields_decisive.includes(field)" style="color:red">
                    *
                  </span>
                </td>
                <td style="min-width: 240px">
                  <template v-if="(service_request_data.category_id == 8 ) && (field == 'Submit photo of cake (Limited to a maximum of 3)')">
                    <vs-images>
                      <vs-image v-for="(media,index) in service_request_data.cakes_images" :key="index" :src="media"/>
                    </vs-images>
                  </template>
                  <template v-else-if="(service_request_data.category_id == 18 ) && (field == 'Submit photo of booth (Limited to a maximum of 3)')">
                    <vs-images>
                      <vs-image v-for="(media,index) in service_request_data.photobooth_images" :key="index" :src="media"/>
                    </vs-images>
                  </template>
                  <template v-else>
                    :
                    {{ value }}
                  </template>
                </td>
              </tr>
            </table>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>


<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleAdmin from '@/store/admin/moduleAdmin.js'
import { db } from '@/firebaseDatabase.js'

export default {

  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      service_request_data: null,
      service_request_not_found: false,
      tab: 0,
      fields_decisive: [
        'Prefer indoor, outdoor or both',
        'Would you use in-house catering?',
        'Would you use in-house bar packages?',
        'Are you planning to use the services of a Wedding Planner for day of coordination'
      ],
      showChat: false,
      chatLog: [],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      chatTitle: "Chat",
      chats: process.env.VUE_APP_CHATS_COLLECTION
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.service_request_data.name}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    deleteRecord () {
      /* Below two lines are just for demo purpose */
      /*this.$router.push({ name: "app-user-list" })
      this.showDeleteSuccess()*/

      /* UnComment below lines for enabling true flow if deleting user */
      this.$store.dispatch('admin/deleteServiceRequests', this.service_request_data.id)
        .then(()   => { this.$router.push({name:'service-request'}); this.showDeleteSuccess() })
        .catch(err => { console.error(err)       })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'Service Request Deleted',
        text: 'The service request was successfully deleted'
      })
    },
    directToTransaction (tr) {
      this.$router
        .push(`/admin/transaction/view/${tr.id}`)
        .catch(() => {})
    },
    directToVendor (tr) {
      this.$router
        .push(`/admin/users/vendor/view/${tr.id}`)
        .catch(() => {})
    },
    directToVendorFromQuote (tr) {
      this.$router
        .push(`/admin/users/vendor/view/${tr.user_id}`)
        .catch(() => {})
    },
    directToConversation (tr) {
      this.chatLog = []
      //console.log(tr)
      //console.log(tr.hashid)
      this.chatTitle = tr.vendor.vendor_professional.business_name
      this.showChat = true
      console.log(this.chats)
      db.collection(this.chats+'/'+tr.hashid+'/messages').orderBy('createdAt', 'asc').get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          let item = doc.data()
          let isVendor = (this.service_request_data.user.uid !== item.participantId)
          let photo = tr.vendor.photo_url
          if(!isVendor){
            photo = this.service_request_data.user.photo_url
          }

          item = {
            isSent: isVendor,
            senderImg: photo,
            msg: item.content,
            type: item.type,
            src: item.src,
            file: item.file,
            timestamp: item.timestamp
          }
          this.chatLog.push(item)
        })
      })

    },
    closeChat (){
      this.showChat = false
    }
  },
  created () {
    this.$emit('changeRouteTitle', 'Service Request')
    // Register Module UserManagement Module
    if (!moduleAdmin.isRegistered) {
      this.$store.registerModule('admin', moduleAdmin)
      moduleAdmin.isRegistered = true
    }

    const id = this.$route.params.id
    this.$store
      .dispatch('admin/fetchServiceRequests', id)
      .then((res) => {
        this.service_request_data = res.data.data

        if (this.$route.query.tab === 'quote' && this.service_request_data.quotes.length) {
          this.tab = 1
        } else if (this.$route.query.tab === 'transaction') {
          if (this.service_request_data.quotes.length && this.service_request_data.transactions.length) {
            this.tab = 2
          } else {
            this.tab = 1
          }
        }
      })
      .catch((err) => {
        if (err.response.status === 404) {
          this.service_request_not_found = true
          return
        }
        console.error(err)
      })
  }
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

.chat-card-log {
    height: 500px;
}
// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
